import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex, Heading, Icon, Image, Stack, Text, VStack } from '@chakra-ui/react';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { FadeRevealWithSSR } from '@src/components/sco/ssr-transitions/FadeRevealWithSSR';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import React from 'react';
type As = React.ElementType;
type HomeListCardProps = {
  bgColor?: string;
  bgGradient?: string;
  bgImage?: string;
  direction?: any;
  title?: string;
  titleTag?: As;
  headline?: string;
  description?: string;
  icon?: any;
  href?: string;
  featuredImage?: string;
  cta?: string;
  addon?: any;
  sideAddon?: any;
  borderRadius?: string;
  style?: React.CSSProperties;
};
export const HomeListCard = props => {
  const $ = _c(66);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = props.bgColor;
  const t1 = `url(${props.bgImage})`;
  const t2 = props.borderRadius || null;
  let t3;
  if ($[0] !== getBreakpointValue) {
    t3 = getBreakpointValue([10, 10, 20]);
    $[0] = getBreakpointValue;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = props.direction;
  let t5;
  if ($[2] !== getBreakpointValue) {
    t5 = getBreakpointValue([10, 12, 12, 12, 24]);
    $[2] = getBreakpointValue;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== props.icon) {
    t6 = <Icon as={props.icon} boxSize={6} color="red.fg" />;
    $[4] = props.icon;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== getBreakpointValue) {
    t7 = getBreakpointValue(["sm", "md", "lg"]);
    $[6] = getBreakpointValue;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== props.title || $[9] !== t7) {
    t8 = <Text color="red.fg/75" fontSize={t7} fontWeight={600}>{props.title}</Text>;
    $[8] = props.title;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <Stack align="center" direction="row" gap={3} width="full">{t6}{t8}</Stack>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = props.titleTag || "h2";
  let t11;
  if ($[14] !== getBreakpointValue) {
    t11 = getBreakpointValue(["480px", "480px", "480px", "480px", "800px"]);
    $[14] = getBreakpointValue;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== getBreakpointValue) {
    t12 = getBreakpointValue(["2xl", "3xl", "4xl", "4xl"]);
    $[16] = getBreakpointValue;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== props.headline || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
    t13 = <Heading as={t10} maxWidth={t11} size={t12}>{props.headline}</Heading>;
    $[18] = props.headline;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== getBreakpointValue) {
    t14 = getBreakpointValue(["lg", "xl"]);
    $[23] = getBreakpointValue;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== getBreakpointValue) {
    t15 = getBreakpointValue(["400px", "400px", "400px", "400px", "800px"]);
    $[25] = getBreakpointValue;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== props.description || $[28] !== t14 || $[29] !== t15) {
    t16 = <Text fontSize={t14} maxWidth={t15} opacity={0.65}>{props.description}</Text>;
    $[27] = props.description;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t13 || $[32] !== t16) {
    t17 = <VStack align="flex-start" gap={4}><FadeRevealWithSSR cascade={true} damping={0.5} direction="up" duration={500} triggerOnce={true}>{t13}{t16}</FadeRevealWithSSR></VStack>;
    $[31] = t13;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== props.cta || $[35] !== props.href) {
    t18 = props.cta && <NextLink href={props.href} passHref={true} prefetch={false}><Button as="span" size="lg" variant="cta">{props.cta}<ChevronRightIcon /></Button></NextLink>;
    $[34] = props.cta;
    $[35] = props.href;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t17 || $[38] !== t18 || $[39] !== t9) {
    t19 = <VStack align="flex-start" flex={1} gap={12}><FadeRevealWithSSR cascade={true} damping={0.5} direction="up" duration={500} triggerOnce={true}>{t9}{t17}{t18}</FadeRevealWithSSR></VStack>;
    $[37] = t17;
    $[38] = t18;
    $[39] = t9;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== getBreakpointValue) {
    t20 = getBreakpointValue([true, true, false]);
    $[41] = getBreakpointValue;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== props.featuredImage || $[44] !== props.sideAddon || $[45] !== props.style) {
    t21 = props.sideAddon ? <Box width="full">{props.sideAddon}</Box> : <Image objectFit="cover" src={props.featuredImage} style={props.style} width="full" />;
    $[43] = props.featuredImage;
    $[44] = props.sideAddon;
    $[45] = props.style;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t20 || $[48] !== t21) {
    t22 = <Flex align="center" flex={1} hidden={t20} justify="center" width="full">{t21}</Flex>;
    $[47] = t20;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== props.direction || $[51] !== t19 || $[52] !== t22 || $[53] !== t5) {
    t23 = <Stack align="center" direction={t4} gap={t5} width="full">{t19}{t22}</Stack>;
    $[50] = props.direction;
    $[51] = t19;
    $[52] = t22;
    $[53] = t5;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== props.addon) {
    t24 = props.addon && <Box width="full">{props.addon}</Box>;
    $[55] = props.addon;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t23 || $[58] !== t24) {
    t25 = <VStack align="flex-start" gap={14} maxWidth="container.2xl" overflow="visible" width="full">{t23}{t24}</VStack>;
    $[57] = t23;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== props.bgColor || $[61] !== t1 || $[62] !== t2 || $[63] !== t25 || $[64] !== t3) {
    t26 = <VStack align="center" bgColor={t0} bgImage={t1} bgPos="center top 5%" bgRepeat="no-repeat" bgSize="contain" borderRadius={t2} overflow="hidden" paddingX={t3} paddingY={10} width="full">{t25}</VStack>;
    $[60] = props.bgColor;
    $[61] = t1;
    $[62] = t2;
    $[63] = t25;
    $[64] = t3;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  return t26;
};